module.exports = __webpack_public_path__ + "static/media/noimage-01.6a5faefc.svg";